import env from '.env.json';

declare let window: any;

// log the pageview with their URL
export const pageview = (url: string) => {
  if (typeof window != undefined && window?.gtag) {
    window.gtag('config', env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      page_path: url,
    })
  }
}

// log specific events happening.
export const event = ({ action, params }) => {
  if (typeof window != undefined && window?.gtag) {
    window.gtag('event', action, params);
  }
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = (): string => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "IOS";
  }

  return '';
}

export const setNewParams = (setParams, params, value: string | number, name: string, page: number | null = null) => {
  let newParams = { ...params, [name]: value };
  if (page) newParams.page = page;

  if (name === 'keyword' && value) {
    event({
      action: "search",
      params: {
        search_term: value
      }
    })
  }

  newParams = ({
    ...newParams,
    [name]: value
  });

  setParams(newParams);

  return newParams;
}
